import styled from 'styled-components';
import { rem, em } from 'polished';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const MetaWrapper = styled.div`
    display: flex;

    &:not(:empty) {
      margin: 3em 0;
    }

    ${media.tabletSmall`
      &:not(:empty) {
        margin: 1em 0;
      }
    `};
`;

export const StyledMetaList = styled.ul`
    list-style: none;
    margin: 0;
    padding-left: 0;

    font-size: ${rem(15)};
    color: ${colors.text};

    &:first-child {
        margin-right: 3em;
    }
`;



// WEBPACK FOOTER //
// ./src/modules/MetaList/styled.js